import React, { PureComponent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainHeader from "components/templateParts/MainHeader";
import SearchBar from "components/templateParts/SearchBar";
import SmartViewsSidebar from "../../../SmartViewsSidebar/SmartViewsSidebar";
import AddPostButton from "../../../ui_components/buttons/AddPostButton";
import Footer from "components/Footer/Footer";
import StatusBarContainer from "./StatusBarContainer";
import SmartTable from "components/ui_components/table/SmartTable";
import dataProvider, {
  UPDATE,
  GET_LIST,
  DOWNLOAD_FILE,
  UPDATE_LIST,
  GET_ONE,
  POST,
  // BULK_DELETE
} from "providers/dataProvider";
import helpers from "utils/helpers";
import {
  getSmartFilterConfig,
  tableColConfig,
} from "config/resources/requisitionsResource/index.js";
import { compose } from "redux";
import withModal from "withModal";
import DeliveryModalContainer from "components/pages/requisitions/RequisitionsShow/Tabs/ReportsDelivery/DeliveryModalContainer";
import Can from "Can";
import { userRoles, userGroups } from "config/userRoles";
import printBarcode from "printer/layout/printBarcode.js";
import printCryo from "printer/layout/printCryo.js";
import { TableHeaderAddButton } from "components/ui_components/buttons";
import Dymo from "printer/printer";
import { withNotificationCenter } from "NotificationCenter";
import {
  getExtraTableConfiguration,
  getDefaultExtraTableConfiguration,
  getResource,
} from "./reqListHelpers";
import { Delivery2Icon } from "icons";
import { withSmartFilter } from 'SmartFilterProvider';
import urlQuery from "urlQuery";
import { filter } from 'lodash';
import filterArrayConfigByPermissions from 'utils/filterArrayConfigByPermissions';
import { withAuthCenter } from 'AuthCenter'
import { TextField, Button, Card, CardContent, Typography, Box } from "@mui/material";

const queryString = require("query-string");

const dymo = new Dymo({
  hostname: "127.0.0.1",
});

const extraDataConfig = {
  byId: ["reasonsFail", "reasonsPass", "labQcStatus", "flags", "depts"],
  byHash: {
    reasonsFail: {
      resource: "reasons/FAIL"
    },
    reasonsPass: {
      resource: "reasons/PASS",
    },
    labQcStatus: {
      resource: "lovs/LABQCSTATUS",
    },
    flags: {
      resource: "flags",
    },
    depts: {
      resource: "depts",
    }
  },
};

class RequisitionsListComponent extends PureComponent {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.query = queryString.parse(props.location.search);

    let initFilterStatus = tableColConfig.groupsByHash.hasOwnProperty(
      this.query.status
    )
      ? this.query.status
      : "All";

    if (helpers.can([userRoles.client])) {
      initFilterStatus = "AllForClient";
    } else if (helpers.can([userRoles.physician])) {
      initFilterStatus = "AllForPhysician";
    } else if (helpers.can([userRoles.billing])) {
      initFilterStatus = "BillingBatch";
    } else if (helpers.can([userRoles.mdcls])) {
      initFilterStatus = ["Approval", "Issues"].includes(this.query.status)
        ? this.query.status
        : "Approval";
    }

    this.state = {
      currentFilterStatus: initFilterStatus,
      selectedRows: [],
      extraTableConfiguration: getDefaultExtraTableConfiguration(),
      resultsInputData: {},
      deliveryReqID: null,
      deliveryModalType: "",
      downloadReportsByFilterInProgress: false,
      isTrfBatchFormOpen: false,
      trfBatchData: {
        count: "",
        assignedToId: null,
      },
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevStatus = urlQuery.getByKeyByQuery('status', prevProps.location.search);
    const currentStatus = urlQuery.getByKeyByQuery('status', this.props.location.search);
    if (prevStatus !== currentStatus) {
      let status = urlQuery.getByKeyByQuery('status', this.props.location.search);
      if (!status) {
        if (helpers.can([userRoles.client])) {
          status = "AllForClient";
        } else if (helpers.can([userRoles.physician])) {
          status = "AllForPhysician";
        } else if (helpers.can([userRoles.billing])) {
          status = "BillingBatch";
        } else if (helpers.can([userRoles.mdcls])) {
          status = "Approval";
        } else {
          status = "All";
        }
      }
      console.log("handleChangeStatus2", status);
      this.smartTable.setPage({}, 0);
      this.setState({
        currentFilterStatus: status
      })
    }
  }

  handleSaveTestResults = (rows) => {
    const { resultsInputData } = this.state;

    const row = rows[0];
    const data = {
      reqTests: resultsInputData[row.id].resultsInputDataById.map((id) => {
        return {
          reqTestId: id,
          result: resultsInputData[row.id].resultsInputDataByHash[id],
        };
      }),
    };

    dataProvider(UPDATE, `requisitions/${row.id}/req_tests/bulk_edit`, {
      data: data,
    })
      .then((response) => {
        this.props.notificationCenter.show("Successfully updated", "info");
        this.smartTable.loadData();
        this.setState({
          resultsInputData: [],
        });
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
      });
  };

  handleChangeStatus = (status) => {
    this.setState(
      {
        currentFilterStatus: status,
      },
      () => {
        urlQuery.push({ status: status }, this.props.navigate);
        this.smartTable.setPage({}, 0);
      }
    );
  };

  handlePrintCryoAction = (rows) => {
    try {
      printCryo(dymo, rows[0]);
    } catch (err) {
      console.error(err);
      this.props.notificationCenter.show("Printing error", "warning");
    }
  };

  handlePrintBarCodeAction = (rows) => {
    try {
      printBarcode(dymo, rows[0]);
    } catch (err) {
      console.error(err);
      this.props.notificationCenter.show("Printing error", "warning");
    }
  };

  handleBulkDownloadResultSource = (rows) => {
    this.handleBulkDownload(rows, "RESULT");
  };

  handleBulkDownloadReportSource = (rows) => {
    this.handleBulkDownload(rows, "REPORT");
  };

  handleBulkDownloadReleaseSource = (rows) => {
    this.handleBulkDownload(rows, "RELEASE");
  };

  handleBulkDownloadDeliverSource = (rows) => {
    // For billing role and BillingBatch status, use special handler
    if (helpers.can([userRoles.billing]) && this.state.currentFilterStatus === "BillingBatch") {
      this.handleBulkDownloadBillingBatches(rows);
    } else {
      this.handleBulkDownload(rows, "DELIVER");
    }
  };


  /**
   * Special handler for downloading requisitions from billing batches
   * For each selected batch, fetches its details to get requisition IDs
   * Then makes a direct API call to bulk_download endpoint exactly matching the curl format
   */
  handleBulkDownloadBillingBatches = async (rows) => {
    if (!rows || rows.length === 0) {
      this.props.notificationCenter.show(
        'Please select at least one billing batch to download',
        'warning'
      );
      return;
    }

    try {
      this.setState({ downloadReportsByFilterInProgress: true });

      // Extract batch IDs from the selected rows
      const billBatchIds = rows.map(row => row.id).filter(Boolean);
      if (billBatchIds.length === 0) {
        this.props.notificationCenter.show(
          'No valid billing batch IDs found in the selection',
          'warning'
        );
        this.setState({ downloadReportsByFilterInProgress: false });
        return;
      }

      // Use the direct billing/batch/bulk_download API
      const billingResponse = await dataProvider(
        POST,
        'billing/batch/bulk_download',
        {
          data: { billBatchIds }
        }
      );

      // The response has already been unwrapped by dataProvider, so we need to check for the URL in the right place
      if (billingResponse && billingResponse.data && billingResponse.data.url) {
        // This is the correct path to the URL based on your actual response
        const url = billingResponse.data.url;
        window.open(url);
        this.props.notificationCenter.showDownloadNotification(url);

        // Show the success message from the response if available
        if (billingResponse.message) {
          this.props.notificationCenter.show(billingResponse.message, 'info');
        } else {
          this.props.notificationCenter.show(
            `Successfully initiated download for ${billBatchIds.length} billing batch(es)`,
            'info'
          );
        }
      } else {
        console.error('Could not find URL in response:', billingResponse);
        this.props.notificationCenter.show(
          'Nothing to download',
          'warning'
        );
      }
    } catch (error) {
      console.error('Error during bulk download:', error);
      this.props.notificationCenter.show(
        'Error during download process. Please try again later.',
        'error'
      );
    } finally {
      this.setState({ downloadReportsByFilterInProgress: false });
    }
  };

  handleBulkDownloadOnlyIsDownloadable = (rows) => {
    const filteredRows = filter(rows, { isDownloadable: 1 })
    this.handleBulkDownload(filteredRows);
  }

  handleBulkDownload = async (rows, callSource = "RESULT") => {
    try {
      const response = await dataProvider(
        DOWNLOAD_FILE,
        `requisitions/bulk_download`,
        {
          data: {
            reqIds: helpers.getAllValues(rows, "id"),
            callSource,
          },
        },
        {
          apiEndointType: "report"
        }
      );

      if (response.data !== null && response.data.hasOwnProperty("url")) {
        window.open(response.data.url);
        this.props.notificationCenter.showDownloadNotification(
          response.data.url
        );
      } else {
        this.props.notificationCenter.show(response.message, "error");
      }
    } catch (error) {
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  handleBulkNotify = async (rows) => {
    try {
      await dataProvider(
        UPDATE_LIST,
        `requisitions/send_notif`,
        {
          data: {
            reqIds: helpers.getAllValues(rows, "id"),
          },
        },
      );
      this.reloadTable();
    } catch (error) {
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  handleBulkNextStatusLogSource = (rows) => {
    this.handleNextStatus(rows, "LOG");
  };

  handleBulkNextStatusAccSource = (rows) => {
    this.handleNextStatus(rows, "ACC");
  };

  handleBulkNextStatusResultSource = (rows) => {
    this.handleNextStatus(rows, "RESULT");
  };

  handleBulkNextStatusReportSource = (rows) => {
    this.handleNextStatus(rows, "REPORT");
  };

  handleBulkNextStatusReleaseSource = (rows) => {
    this.handleNextStatus(rows, "RELEASE");
  };
  handleBulkDelete = () => {
    this.smartTable.handleClickDelete();
  };

  handleNextStatus = (rows, callSource) => {
    dataProvider(
      UPDATE,
      `requisitions/${rows[0].reqStatusCode
      }/next_status/bulk_move?id=${helpers.getAllValues(rows, "id")}`,
      {
        data: {
          callSource: callSource,
        },
      }
    )
      .then((response) => {
        this.props.notificationCenter.show(
          `Successfully updated status`,
          "info"
        );
        this.smartTable.loadData();
        this.statusBar.loadData();
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
      });
  };

  handleDeliveryClick = (rows) => {
    this.setState(
      {
        deliveryReqID: rows[0].id,
        deliveryModalType: "single",
      },
      () => {
        this.props.handleOpenModal();
      }
    );
  };

  handleBulkDeliveryClick = (rows) => {
    this.setState(
      {
        selectedRows: rows,
        deliveryModalType: "bulk",
      },
      () => {
        this.props.handleOpenModal();
      }
    );
  };

  handleGoToStatus = (rows) => {
    let reqStatusCode = null;

    if (rows[0].reqStatusCode === "RELEASE") {
      reqStatusCode = "ACC";
    } else {
      return;
    }

    dataProvider(UPDATE, `requisitions`, {
      data: { reqStatusCode: reqStatusCode },
      id: rows[0].id,
    })
      .then((response) => {
        this.props.notificationCenter.show(
          `Successfully updated status`,
          "info"
        );
        this.smartTable.loadData();
        this.statusBar.loadData();
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
      });
  };

  handleSubTableRowsInputData = (data) => {
    const { inputDataByHash, row, parentRow } = data;

    this.setState((prevState) => {
      const parentRowID = parentRow.id;

      let updatedRow = {};

      if (prevState.resultsInputData.hasOwnProperty(parentRowID)) {
        updatedRow = {
          resultsInputDataById: prevState.resultsInputData[
            parentRow.id
          ].resultsInputDataById.includes(row.id)
            ? prevState.resultsInputData[parentRow.id].resultsInputDataById
            : prevState.resultsInputData[
              parentRow.id
            ].resultsInputDataById.concat(row.id),
          resultsInputDataByHash: {
            ...prevState.resultsInputData[parentRow.id].resultsInputDataByHash,
            [row.id]: inputDataByHash.result,
          },
        };
      } else {
        updatedRow = {
          resultsInputDataById: [row.id],
          resultsInputDataByHash: { [row.id]: inputDataByHash.result },
        };
      }

      return {
        resultsInputData: {
          ...prevState.resultsInputData,
          [parentRow.id]: updatedRow,
        },
      };
    });
  };


  handleToggleTrfBatchForm = () => {
    this.setState({ isTrfBatchFormOpen: !this.state.isTrfBatchFormOpen });
  };

  handleTrfBatchInputs = (e) => {
    const { name, value } = e.target;

    // Prevent negative values for count
    if (name === "count" && value !== "" && (parseInt(value, 10) < 1)) {
      if (value === "0") {
         // Allow empty or handle 0 if needed, but per user request of not wanting negative, 
         // we can just return if it's less than 1 or handle it in the keydown.
         // Let's just allow empty but not negative.
      }
      if (parseInt(value, 10) < 0) return;
    }

    this.setState({
      trfBatchData: {
        ...this.state.trfBatchData,
        [name]: value,
      },
    });
  };

  handleGenerateTrfBatch = () => {
    const { trfBatchData } = this.state;
    if (!trfBatchData.count) {
      this.props.notificationCenter.show("Please fill all fields", "warning");
      return;
    }

    dataProvider(POST, 'requisitions/trf/gen_batch', {
      data: {
        trfCount: parseInt(trfBatchData.count, 10),
        trfQueueUserId: trfBatchData.assignedToId,
      }
    })
      .then(response => {
        this.props.notificationCenter.show("Successfully generated TRF Batch", "info");
        this.setState({ isTrfBatchFormOpen: false, trfBatchData: { count: "", assignedToId: null } });
        this.reloadTable();

        // Extract generated req IDs from API response, sort ascending, then open Edit TRF
        let generatedIds = [];
        const resData = response?.data;
        if (Array.isArray(resData)) {
          generatedIds = resData.map(item => {
            if (typeof item === 'object') {
              return item.reqId || item.id;
            }
            return item;
          }).filter(Boolean);
        } else if (resData?.ids && Array.isArray(resData.ids)) {
          generatedIds = resData.ids;
        } else if (resData?.reqIds && Array.isArray(resData.reqIds)) {
          generatedIds = resData.reqIds;
        }

        if (generatedIds.length > 0) {
          const sortedIds = [...generatedIds].map(Number).sort((a, b) => a - b);
          const lowestId = sortedIds[0];
          const batchParam = sortedIds.join(',');
          this.props.navigate(`/edit-trf/${lowestId}?batchIds=${batchParam}`);
        }
      })
      .catch(error => {
        console.error('[gen_batch error]', error?.response || error);
        const msg = error?.response?.data?.message || error.message || 'Server Error';
        this.props.notificationCenter.show(msg, "error");
      });
  };

  reloadTable = () => {
    this.smartTable.loadData();
  };

  /**
   * Fetches billing batches from the API
   * @returns {Promise<Object>} Response from the API
   */
  handleFetchBillingBatch = async () => {
    try {
      // Matching your successful curl format exactly
      const response = await dataProvider(
        GET_LIST,
        'billing/batch',

        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      if (response && response.data) {
        console.table(response.data);
        this.props.notificationCenter.show(
          `Successfully fetched ${response.data.length} billing batches`,
          "info"
        );
      } else {
        this.props.notificationCenter.show("No billing batches found", "warning");
      }

      return response;
    } catch (error) {
      console.error('Billing Batch API Error:', error);
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  /**
   * Fetches details of a specific billing batch
   * @param {number} batchId - ID of the batch to fetch details for
   * @returns {Promise<Object>} Response from the API
   */
  handleFetchBillingBatchDetails = async (batchId = 1) => {
    try {
      // Using same token format for consistency
      const response = await dataProvider(
        GET_ONE,
        `billing/batch/details/${batchId}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      if (response && response.data) {
        console.table(response.data);
        this.props.notificationCenter.show(
          `Successfully fetched details for billing batch #${batchId}`,
          "info"
        );
      } else {
        this.props.notificationCenter.show(`No details found for billing batch #${batchId}`, "warning");
      }

      return response;
    } catch (error) {
      console.error(`Billing Batch Details API Error for ID ${batchId}:`, error);
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  /**
   * Handles the download of billing batch details for a specific requisition ID
   * Uses the exact API endpoint format from the curl command
   * @param {object} row - The row data containing the requisition ID
   */
  handleBillingDetailsDownload = (row) => {
    try {
      // For sub-table rows, we need to use the requisitionId (reqId) field
      // Make sure we're getting the correct ID from the row data
      let reqId;

      if (typeof row === 'object') {
        // If row is a full object with properties
        reqId = row.reqId || row.requisitionId || row.id;
      } else {
        // If row is a direct ID value
        reqId = row;
      }

      if (!reqId) {
        this.props.notificationCenter.show("No requisition ID found in selected row", "warning");
        return;
      }

      // Using the direct API endpoint with v3.0 prefix as specified in the curl command      
      dataProvider(
        POST,
        `billing/batch/details/download/${reqId}`,
        { data: {} }
      )
        .then((response) => {
          // Extract URL from response
          let url;
          if (response.data && response.data.url) {
            url = response.data.url;
          } else if (response.data && response.data.data && response.data.data.url) {
            url = response.data.data.url;
          }

          if (url && typeof url === "string") {
            window.open(url, "_blank");
            this.props.notificationCenter.showDownloadNotification(url);
            this.props.notificationCenter.show(
              `Successfully downloaded details for requisition #${reqId}`,
              "info"
            );
          } else {
            console.error("Could not find URL in response:", response);
            this.props.notificationCenter.show(
              "Nothing to download",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.error(`Error downloading billing batch details for requisition ID ${reqId}:`, error);
          this.props.notificationCenter.show(error.message, "error");
        });
    } catch (error) {
      console.error("Error in handleBillingDetailsDownload:", error);
      this.props.notificationCenter.show(error.message, "error");
    }
  };

  handleDownloadReportsByFilter = () => {
    this.setState({
      downloadReportsByFilterInProgress: true,
    });
    dataProvider(
      GET_LIST,
      `${getResource(this.state.currentFilterStatus)}/export`,
      {
        filter: { ...this.props.smartFilter.getFilter() },
      },
      {
        apiEndointType: 'report',
      }
    )
      .then(({ data, total, message }) => {

        if (data !== null && data.hasOwnProperty("url")) {
          window.open(data.url);
          this.props.notificationCenter.show(
            "If download failed, please click here",
            "info",
            "Download",
            () => { },
            data.url
          );
        } else {
          this.props.notificationCenter.show(message, "error");
        }
        this.setState({
          downloadReportsByFilterInProgress: false,
        });
      })
      .catch((error) => {
        this.props.notificationCenter.show(error.message, "warning");
        this.setState({
          downloadReportsByFilterInProgress: false,
        });
      });
  };

  render() {
    const {
      deliveryReqID,
      selectedRows,
      deliveryModalType,
    } = this.state;
    const {
      modalOpen,
      handleCloseModal,
      tableColConfigByHashWithExtraData,
    } = this.props;

    const tableFilter = this.props.smartFilter.getFilter();

    const currentColumnGroup = tableColConfig.groupsByHash[this.state.currentFilterStatus] || tableColConfig.groupsByHash["MDCLS"];
    let columns = currentColumnGroup;

    if (currentColumnGroup.hasOwnProperty("tableColById")) {
      columns = helpers.byHashByIDConfToArray(
        currentColumnGroup.tableColById,
        tableColConfigByHashWithExtraData || currentColumnGroup.tableColByHash
      );
    }

    const actionHandlers = {
      handleGoToStatus: this.handleGoToStatus,
      handleNextStatus: this.handleNextStatus,
      handleBulkNextStatusLogSource: this.handleBulkNextStatusLogSource,
      handleBulkNextStatusAccSource: this.handleBulkNextStatusAccSource,
      handleBulkNextStatusReportSource: this.handleBulkNextStatusReportSource,
      handleBulkNextStatusResultSource: this.handleBulkNextStatusResultSource,
      handleBulkNextStatusReleaseSource: this.handleBulkNextStatusReleaseSource,
      handlePrintCryoAction: this.handlePrintCryoAction,
      handlePrintBarCodeAction: this.handlePrintBarCodeAction,
      handleBulkDownloadResultSource: this.handleBulkDownloadResultSource,
      handleBulkDownloadReportSource: this.handleBulkDownloadReportSource,
      handleBulkDownloadReleaseSource: this.handleBulkDownloadReleaseSource,
      handleBulkDownloadDeliverSource: this.handleBulkDownloadDeliverSource,
      handleDeliveryClick: this.handleDeliveryClick,
      handleBulkDownload: this.handleBulkDownload,
      handleBulkNotify: this.handleBulkNotify,
      handleBulkDownloadOnlyIsDownloadable: this.handleBulkDownloadOnlyIsDownloadable,
      handleBulkDeliveryClick: this.handleBulkDeliveryClick,
      handleSaveTestResults: this.handleSaveTestResults,
      handleBulkDelete: this.handleBulkDelete,
      handleFetchBillingBatch: this.handleFetchBillingBatch,
      handleFetchBillingBatchDetails: this.handleFetchBillingBatchDetails,
      handleBillingDetailsDownload: this.handleBillingDetailsDownload,
      handleBulkDownloadBillingBatches: this.handleBulkDownloadBillingBatches,
    };

    const smartFilterConfig = getSmartFilterConfig();
    const filteredByPermissionsSmartFilterConfig = filterArrayConfigByPermissions(smartFilterConfig, this.props.authCenter.access.userRoleCode);
    let headerTitle = "Requisitions";
    if (helpers.can([userRoles.billing])) {
      headerTitle = "Billed Requisitions";
    } else if (helpers.can([userRoles.mdcls])) {
      headerTitle = "MDCLS";
    }

    return (
      <div>
        <DeliveryModalContainer
          modalOpen={modalOpen}
          handleCloseModal={handleCloseModal}
          resource={
            deliveryModalType === "single"
              ? `requisitions/${deliveryReqID}/rep_delivery`
              : `requisitions/bulk_delivery`
          }
          handleSubmitOK={this.reloadTable}
          submitData={
            deliveryModalType === "single"
              ? {}
              : {
                reqIds: helpers.getAllValues(selectedRows, "id"),
              }
          }
        />

        <MainHeader
          title={headerTitle}
          button={
            <Can
              allowedRoles={[
                userRoles.admin,
                userRoles.management,
                userRoles.lisstaff,
              ]}
            >
              <Box sx={{ display: 'flex', gap: 1 }}>
                <AddPostButton
                  title="TRF Batch"
                  onClick={this.handleToggleTrfBatchForm}
                  style={{ backgroundColor: '#004C6A' }}
                />
                <AddPostButton title="Requisitions" href="/requisitions/create" />
              </Box>
            </Can>
          }
        />
        <SearchBar />
        <SmartViewsSidebar
          isOpen={true}
          resource="requisitions"
          smartFilterConfig={filteredByPermissionsSmartFilterConfig}
        >
          <div className="mainContainer">
            <div className="mainContainer__inner">
              {this.state.isTrfBatchFormOpen && (
                <Card sx={{ mb: 2, border: '1px solid #ccc', maxWidth: 400, mx: 'auto', mt: 2 }}>
                  <CardContent>
                    <Typography variant="h6" align="center" sx={{ fontWeight: 700, mb: 2 }}>
                      Generate Place Holder Requisition
                    </Typography>
                    <Box>
                      <Typography variant="body2" sx={{ mb: 0.5 }}>
                        Number of requisitions to generate
                      </Typography>
                      <TextField
                        fullWidth
                        type="number"
                        name="count"
                        variant="standard"
                        value={this.state.trfBatchData.count}
                        onChange={this.handleTrfBatchInputs}
                        sx={{ mb: 2 }}
                        inputProps={{ min: 1 }}
                        onKeyDown={(e) => {
                          if (["-", "e", "+"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                        <Button
                          variant="contained"
                          sx={{ backgroundColor: '#004C6A', '&:hover': { backgroundColor: '#004C6A' }, textTransform: 'none', px: 4 }}
                          onClick={this.handleGenerateTrfBatch}
                        >
                          Generate
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              )}
              <Can allowedRoles={[...userGroups.superAdmins, userRoles.mdcls]}>
                <StatusBarContainer
                  onRef={(ref) => (this.statusBar = ref)}
                  handleChangeStatus={this.handleChangeStatus}
                  currentFilterStatus={this.state.currentFilterStatus}
                />
              </Can>
              <SmartTable
                {...getExtraTableConfiguration({
                  status: this.state.currentFilterStatus,
                  actionHandlers: actionHandlers,
                  smartFilter: this.props.smartFilter.getFilter(), // Pass FULL filter (includes requisition fields) for sub-table
                  resultsInputData: this.state.resultsInputData,
                })}
                onRef={(ref) => (this.smartTable = ref)}
                deleteConfirmationMessagePostfix="requisition"
                columns={columns}
                filter={tableFilter}
                resource={getResource(this.state.currentFilterStatus)}
                showDelete={false}
                handleSubTableRowsInputData={this.handleSubTableRowsInputData}
                extraDataConfig={extraDataConfig}
                order={"desc"}
                actionHandlers={actionHandlers}
                toolbarExtraComponents={
                  <React.Fragment>
                    <Can notAllowedRoles={[userRoles.client, userRoles.physician, userRoles.sales, userRoles.billing, userRoles.collaborator]}>
                      <TableHeaderAddButton
                        icon={<Delivery2Icon />}
                        onClick={this.handleDownloadReportsByFilter}
                        showProgressBar={
                          this.state.downloadReportsByFilterInProgress
                        }
                      >
                        Export All
                      </TableHeaderAddButton>
                    </Can>
                  </React.Fragment>
                }
              />
            </div>
            <Footer />
          </div>
        </SmartViewsSidebar>
      </div>
    );
  }
}

const RequisitionsListWithCompose = compose(
  withAuthCenter(),
  withSmartFilter(),
  withModal,
  withNotificationCenter()
)(RequisitionsListComponent);

// Wrapper component to inject location and navigate from React Router v6
const RequisitionsListComponentWrapper = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  return <RequisitionsListWithCompose {...props} location={location} navigate={navigate} />;
};

export default RequisitionsListComponentWrapper;
